import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PageSkeleton } from './LoadingState';

/** Reset private page state and polling whenever its verified access scope changes. */
export function AccountRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { user, isLoading, isAuthenticated, mutationRefresh, refreshAfterMutation } = useAuth();
  if (isLoading) return <PageSkeleton />;
  if (!isAuthenticated || !user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (mutationRefresh?.status === 'refreshing') return <PageSkeleton />;
  if (mutationRefresh?.status === 'failed') {
    const change = mutationRefresh.kind === 'email' ? 'email change' : 'password change';
    return <div className="mx-auto max-w-xl rounded-xl border border-amber-200 bg-amber-50 p-8" role="alert">
      <h1 className="text-xl font-semibold text-gray-900">Account status needs verification</h1>
      <p className="mt-3 text-gray-700">Your {change} was saved, but account status could not be refreshed. Private actions remain blocked until verification succeeds.</p>
      <button
        onClick={() => void refreshAfterMutation(mutationRefresh.kind).catch(() => undefined)}
        className="mt-6 rounded-lg bg-vedra-hunter px-4 py-2 text-white"
      >
        Retry account status
      </button>
    </div>;
  }
  if (user.force_password_change && location.pathname !== '/dashboard/profile') {
    return <Navigate to="/dashboard/profile?password_change=required" replace />;
  }
  return <React.Fragment key={`${user.id}:${user.cache_scope || ''}`}>{children}</React.Fragment>;
}
